/**
 * @module cors
 * @description CORS info-page behavior — auto-opens a <details> element
 * matching the URL fragment, both on load and on hashchange.
 * Built into /js/cors.js by scripts/build-client.js.
 */
export {};

function openFromHash(): void {
  const hash = window.location.hash.slice(1);
  if (!hash) return;
  const el = document.getElementById(hash);
  if (el && el.tagName === 'DETAILS') {
    (el as HTMLDetailsElement).open = true;
  }
}

openFromHash();
window.addEventListener('hashchange', openFromHash);
